<p-dialog
  [visible]="travelBoardService.showTransferDialog()"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '90%', maxWidth: '450px' }"
  (onHide)="onClose()"
>
  <ng-template pTemplate="header">
    <div class="flex items-center gap-2">
      <i class="pi pi-arrow-right-arrow-left text-xl text-primary-500"></i>
      <span class="font-semibold">{{ 'travelBoards.transferTrip' | transloco }}</span>
    </div>
  </ng-template>

  <div class="flex flex-col gap-4">
    <p class="text-sm text-greyscale-600">
      {{ 'travelBoards.transferDescription' | transloco }}
    </p>

    @if (travelBoardService.transferTripTitle()) {
      <div class="rounded-lg bg-greyscale-50 p-3">
        <p class="text-xs text-greyscale-500">{{ 'travelBoards.tripToTransfer' | transloco }}</p>
        <p class="font-medium text-greyscale-800">{{ travelBoardService.transferTripTitle() }}</p>
      </div>
    }

    <!-- Company selector -->
    <div class="flex flex-col gap-2">
      <label for="target-company" class="text-sm font-medium text-greyscale-700">
        {{ 'travelBoards.selectTargetCompany' | transloco }}
      </label>
      <p-select
        inputId="target-company"
        [options]="companies"
        [(ngModel)]="selectedCompanyId"
        optionLabel="label"
        optionValue="value"
        [placeholder]="'travelBoards.selectCompanyPlaceholder' | transloco"
        styleClass="w-full"
        appendTo="body"
        [loading]="isLoading"
        [filter]="true"
        filterBy="label"
      />
    </div>

    @if (selectedCompanyId) {
      <div
        class="rounded-lg border border-orange-200 bg-orange-50 p-3 text-sm text-orange-700"
        role="alert"
      >
        <i class="pi pi-exclamation-triangle mr-2"></i>
        {{ 'travelBoards.transferWarning' | transloco }}
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        [label]="'cancel' | transloco"
        [text]="true"
        severity="secondary"
        (onClick)="onClose()"
      />
      <p-button
        [label]="'travelBoards.transfer' | transloco"
        icon="pi pi-arrow-right"
        (onClick)="onTransfer()"
        [loading]="isTransferring"
        [disabled]="!selectedCompanyId"
      />
    </div>
  </ng-template>
</p-dialog>
